import React, { useCallback } from 'react'
import settings from '@nobia/zeus-components/lib/settings'

export const BadaDevIframed = () => {
  const postClose = useCallback(() => {
    window.parent.postMessage('prepform-completed')
  }, [])

  return (
    <div
      style={{
        padding: '1rem 2rem',
        margin: '0 auto',
        maxWidth: '460px',
        textAlign: 'center',
      }}
    >
      <h1>BADA Dev MP</h1>
      <p>
        In other environments this page will contain actual iframe of the bada.
        If you want to make any changes to the appointment use the link below.
        After the changes have been done close this iframe and the appointment
        should update
      </p>
      <a
        href={
          settings.brandUrl + window.location.pathname + window.location.search
        }
        target="_blank"
        rel="noreferrer"
        style={{ display: 'block', marginBottom: '1rem' }}
      >
        Link to bada that would have been iframed
      </a>
      {window.location.pathname === settings.bada.embedUrl && (
        <button
          style={{ padding: '0.5rem 1rem', border: '1px solid black' }}
          onClick={postClose}
        >
          Send prepform event completed
        </button>
      )}
    </div>
  )
}
